import { FC, useMemo } from 'react';
import {
  Button,
  InputCheckbox,
  InputGroup,
  ModalInfo,
  ModalInfoProps,
} from '@/components';
import { userActions } from '@/redux/actions';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { userSelectors } from '@/redux/selectors';
import { useInputBool } from '@/hooks';
import { Validation } from '@/models';
import { ReceiveRemindersRequest } from '@/api';

import styles from './ReceiveRemindersModal.module.sass';

interface ReceiveRemindersModalProps extends ModalInfoProps {}

const ReceiveRemindersModal: FC<ReceiveRemindersModalProps> = (props) => {
  const { isOpen, onClose } = props;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const {
    data: userData,
    loading,
    error,
  } = useAppSelector(userSelectors.getUserSlice);

  const CHECKBOX_VALIDATIONS: Validation[] = useMemo(() => [], []);
  const receiveField = useInputBool(
    userData?.receiveReminders ?? true,
    CHECKBOX_VALIDATIONS,
  );

  const handleSubmit = () => {
    const payload: ReceiveRemindersRequest = {
      value: receiveField.value,
    };
    dispatch(userActions.changeReceiveReminders(payload));
  };
  return (
    <ModalInfo
      isOpen={isOpen}
      title={t('translation.reminder_section_title')}
      actions={
        <>
          <Button
            type="primary"
            corner="rect"
            onClick={handleSubmit}
            isLoading={loading}
            disabled={loading}
          >
            {t('translation.save_changes_btn')}
          </Button>
          <Button type="secondary" corner="rect" onClick={onClose}>
            {t('translation.cancel_btn')}
          </Button>
        </>
      }
      className={styles.modal}
      onClose={onClose}
    >
      <div className={styles.list}>
        <InputGroup>
          <InputCheckbox
            id="autoAdd"
            name="autoAdd"
            value={receiveField.value as boolean}
            onChange={receiveField.onChange}
            required
          >
            <span className={styles.label}>
              {parse(t('translation.receive_reminder_description'))}
            </span>
          </InputCheckbox>
        </InputGroup>
      </div>
    </ModalInfo>
  );
};

export default ReceiveRemindersModal;
